// extracted by mini-css-extract-plugin
export default {"wrapper":"AuctionActivityWrapper_wrapper__q1NGu"};